import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { AccountService } from '../services/account.service';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService, public errorDialogService: ToastService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {

                return event;
            }),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    // auto logout if 401 response returned from api
                  this.accountService.logout();
                  return;
                }

                this.errorDialogService.showDanger(err.error);
                return throwError(err);
            }));
    }
}
